import React, { useCallback, useMemo, useState } from "react";
import { Button, RadioGroup } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { useChangeCampaignSettingsMutation, useOrganizationSettingsQuery } from "../../graphql/generated/graphql";
import { CheckmarkIcon } from "../Icons";
import { SmallLoader } from "../SmallLoader";

export const ExtendedConversions = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.AdvancedSetup" });
  const [value, setValue] = useState<boolean>(true);
  const [isSaved, setIsSaved] = useState(false);

  const { data, loading } = useOrganizationSettingsQuery({
    onCompleted(dataResponse) {
      setValue(
        typeof dataResponse.organization?.extendedConversions === "undefined" ||
          dataResponse.organization?.extendedConversions === null
          ? true
          : dataResponse.organization?.extendedConversions
      );
    },
  });

  const [changeCampaignSetting, { loading: mutationLoading }] = useChangeCampaignSettingsMutation({
    onCompleted: () => {
      setIsSaved(true);
      setTimeout(() => setIsSaved(false), 2000);
    },
  });

  const onChange = useCallback((newValue: string | null) => setValue(newValue === "true"), [setValue]);

  const options = useMemo(
    () => [
      { value: "true", label: t("Extended Conversions On") },
      { value: "false", label: t("Extended Conversions Off") },
    ],
    [t]
  );

  if (loading || !data?.organization) {
    return <SmallLoader />;
  }

  return (
    <div>
      <RadioGroup
        disabled={mutationLoading || isSaved}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        name="extended_conversions"
        options={options}
        value={String(value)}
        onChange={onChange}
      />
      {(data.organization?.extendedConversions === value && !mutationLoading && !isSaved && <span />) || (
        <div style={{ margin: "10px 10px 0 0" }}>
          <Button
            data-test-id="save-extended-conversions"
            disabled={mutationLoading || isSaved}
            variant="action"
            onClick={() => changeCampaignSetting({ variables: { extendedConversions: value } })}
          >
            {(isSaved && (
              <span style={{ display: "flex", alignItems: "center" }}>
                <CheckmarkIcon /> &nbsp; {t("Saved")}
              </span>
            )) ||
              (mutationLoading && t("Saving")) ||
              t("Save")}
          </Button>
        </div>
      )}
    </div>
  );
};
